import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import Stack from '@/design_system/Stack';
import { CommentsSection } from '@/routes/Requests/components/CommentsSection';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { NewArticleDetails } from '@/routes/Requests/New/components/ArticleForm';
import { AuthenticityForm } from '@/routes/Requests/Request/Article/AuthenticityForm';
import { WarrantyForm } from '@/routes/Requests/Request/Article/WarrantyForm';
import useViewPort from '@/utils/useViewport';

export const NewArticleBodyFormInformation = ({
  alertRef,
}: {
  alertRef: React.RefObject<HTMLDivElement | null>;
}) => {
  const { isMobile } = useViewPort();
  const { request } = useRequestContext();
  const { article, hasError } = useArticleContext();

  return (
    <Stack padding={isMobile ? '1rem' : '1.5rem 2rem'}>
      <Stack
        ref={alertRef}
        style={{
          marginBottom: hasError ? '1rem' : undefined,
        }}
        gap="0.5rem"
      >
        {hasError && (
          <AlertBar
            type="error"
            title={
              <Trans id="requests.edit.articles.alert.missing-info">
                Please fill the missing information.
              </Trans>
            }
          />
        )}
      </Stack>
      <Stack gap="2rem">
        <NewArticleDetails />

        <WarrantyForm />

        <AuthenticityForm />

        <CommentsSection articleId={article.id} requestId={request.id} />
      </Stack>
    </Stack>
  );
};
